import { render, staticRenderFns } from "./TabulatorView.vue?vue&type=template&id=f471814e&scoped=true&"
import script from "./TabulatorView.vue?vue&type=script&lang=js&"
export * from "./TabulatorView.vue?vue&type=script&lang=js&"
import style0 from "./TabulatorView.vue?vue&type=style&index=0&id=f471814e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f471814e",
  null
  
)

export default component.exports